






























































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwBarProgress } from '@libs-uuif/shared/sw-progress';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { MswProductsTabRoute } from '@/modules/msw-products';
// import  { MswApiService } from '@/shared/msw-api-service';
import { State } from 'vuex-class';
import { DashBoardStoreState } from '@/modules/msw-dashboard/msw-dashboard.store';
import { RootStoreState } from '@/store';

const cssPrefix = 'msw-licensestatus-widget';

@Component({
  components: {
    MswWidgetCard,
    SwBarProgress,
    SwIcon,
  },
})
export default class MswLicensestatusWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  progressBarBackgroundColor = '#d8d8d8';
  @State((state: RootStoreState) => state.DashBoardStoreModule.widgetCustomerInfo)
  widgetCustomerInfo : {
    totExpiredProducts : DashBoardStoreState['widgetCustomerInfo']['totExpiredProducts'],
    totSoonExpiringProducts : DashBoardStoreState['widgetCustomerInfo']['totSoonExpiringProducts']
    productsCount : DashBoardStoreState['widgetCustomerInfo']['productsCount'],
  };
  expiringSoonColor = '#f58f0f';
  expiredValColor  = '#d0021b';
  waitForResp = false;
  routeToProductsPage() {
    // Route to page and in future use the License expiry alerts filter
    this.$router.push({ path: `/m/feature/${MswProductsTabRoute.path}?tab=expiring` });
    window.parent.postMessage({
      redirectUrl : `/m/feature/${MswProductsTabRoute.path}?tab=expiring`,
    },                        '*');
  }
}
